export const getSubReddit = function (link: string) {
  const spilits = link.split('/').filter(Boolean);
  if (spilits.length > 3) return [spilits[2], spilits[3]].join('/');
  return link;
};
